'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTilePrice = renderWithRef('StandardTilePrice', null, (a, o)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-standard-tile-price'
        ],
        props: a,
        children: a.children
    }));

export { StandardTilePrice };
